/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Merge_ConfirmInputs */

const en_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_speaker_manager_merge_confirm = /** @type {(inputs: Speaker_Manager_Merge_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Speaker_Manager_Merge_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_merge_confirm = /** @type {((inputs?: Speaker_Manager_Merge_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Merge_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_merge_confirm(inputs)
	if (locale === "de") return de_speaker_manager_merge_confirm(inputs)
	if (locale === "it") return it_speaker_manager_merge_confirm(inputs)
	if (locale === "ru") return ru_speaker_manager_merge_confirm(inputs)
	if (locale === "es") return es_speaker_manager_merge_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_merge_confirm(inputs)
	if (locale === "ja") return ja_speaker_manager_merge_confirm(inputs)
	if (locale === "hi") return hi_speaker_manager_merge_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_merge_confirm(inputs)
	return en_speaker_manager_merge_confirm(inputs)
});